// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuotes";
import loadCustomerPartNumbers from "@vanmeter/App/Handlers/CPN/loadCustomerPartNumbers";
import { xIsAuthenticated } from "@vanmeter/App/Store/Selectors/GeneralSelectors";

// XNG-Changes:
export const xloadCustomerPartNumbers: typeof PopulateApiParameter = props => {
    const isAuth = xIsAuthenticated(props.getState());

    if (!props.apiResult?.quotes || props.apiResult.quotes.length === 0 || !isAuth) {
        return;
    }
    const productIds = props.apiResult.quotes.map(quoteLine => quoteLine.id);

    props.dispatch(
        loadCustomerPartNumbers({
            productIds,
        }),
    );
};

addToEndOfChain(chain, xloadCustomerPartNumbers);
